var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaplWordmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 239.86667 102.45333",
    height: 102.45333,
    width: 239.86667,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,102.45333)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 361.164,641.797 c -17.281,0 -31.539,7.129 -45.129,18.359 l -19.66,-23.539 c 18.141,-16.191 41.25,-24.179 64.141,-24.179 32.613,0 55.511,16.839 55.511,46.847 v 0.442 c 0,26.351 -17.281,37.359 -47.953,45.351 -26.129,6.699 -32.609,9.942 -32.609,19.867 v 0.442 c 0,7.328 6.691,13.172 19.437,13.172 12.743,0 25.926,-5.61 39.305,-14.911 l 17.277,25.059 c -15.332,12.309 -34.121,19.219 -56.148,19.219 -30.883,0 -52.91,-18.141 -52.91,-45.567 v -0.429 c 0,-30.02 19.652,-38.453 50.101,-46.223 25.278,-6.48 30.457,-10.801 30.457,-19.219 v -0.433 c 0,-8.86 -8.207,-14.258 -21.82,-14.258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 502.234,611.996 c 29.161,0 46.442,10.371 61.993,27.004 l -21.184,21.371 c -11.867,-10.793 -22.449,-17.711 -39.73,-17.711 -25.911,0 -43.84,21.598 -43.84,47.52 v 0.429 c 0,25.911 18.363,47.082 43.84,47.082 15.121,0 27,-6.48 38.66,-17.062 l 21.16,24.41 c -14.031,13.809 -31.09,23.32 -59.61,23.32 -46.429,0 -78.82,-35.199 -78.82,-78.179 v -0.43 c 0,-43.422 33.043,-77.754 77.531,-77.754"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 610.723,675.27 h 67.89 v -60.68 h 33.266 v 151.18 h -33.266 v -59.817 h -67.89 v 59.817 h -33.27 V 614.59 h 33.27 v 60.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 765.012,690.609 c 0,25.911 18.578,47.082 45.359,47.082 26.777,0 45.789,-21.601 45.789,-47.511 v -0.43 c 0,-25.922 -18.582,-47.09 -45.355,-47.09 -26.785,0 -45.793,21.598 -45.793,47.52 z m 45.359,-78.613 c 46.649,0 80.559,35.199 80.559,78.184 v 0.429 c 0,42.981 -33.477,77.75 -80.125,77.75 -46.653,0 -80.555,-35.199 -80.555,-78.179 v -0.43 c 0,-42.98 33.473,-77.754 80.121,-77.754"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 936.035,690.609 c 0,25.911 18.586,47.082 45.363,47.082 26.782,0 45.792,-21.601 45.792,-47.511 v -0.43 c 0,-25.922 -18.58,-47.09 -45.362,-47.09 -26.777,0 -45.793,21.598 -45.793,47.52 z m 45.363,-78.613 c 46.652,0 80.552,35.199 80.552,78.184 v 0.429 c 0,42.981 -33.46,77.75 -80.122,77.75 -46.648,0 -80.551,-35.199 -80.551,-78.179 v -0.43 c 0,-42.98 33.469,-77.754 80.121,-77.754"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1188.64,644.828 h -75.37 V 765.77 h -33.26 V 614.59 h 108.63 v 30.238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1284.97,690.609 c 0,25.911 18.59,47.082 45.36,47.082 26.78,0 45.79,-21.601 45.79,-47.511 v -0.43 c 0,-25.922 -18.57,-47.09 -45.36,-47.09 -26.77,0 -45.79,21.598 -45.79,47.52 z m 45.36,-78.613 c 46.65,0 80.57,35.199 80.57,78.184 v 0.429 c 0,42.981 -33.48,77.75 -80.14,77.75 -46.65,0 -80.54,-35.199 -80.54,-78.179 v -0.43 c 0,-42.98 33.46,-77.754 80.11,-77.754"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1462.21,673.121 h 72.14 v 30.238 h -72.14 v 32.184 h 81.84 v 30.227 h -115.1 V 614.59 h 33.26 v 58.531"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 177.238,473.863 20.082,49.032 20.09,-49.032 z m 35.84,88.981 h -30.66 L 117.629,410.582 h 33.91 l 13.82,33.922 h 63.93 l 13.824,-33.922 h 34.77 l -64.805,152.262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 321.676,531.746 h 33.043 c 16.203,0 26.136,-7.336 26.136,-21.601 v -0.426 c 0,-12.742 -9.285,-21.379 -25.488,-21.379 h -33.691 z m 0,-72.777 h 26.144 l 32.375,-48.383 h 38.883 l -36.933,54.004 c 19.234,7.129 32.394,22.445 32.394,46.859 v 0.43 c 0,14.25 -4.531,26.141 -12.949,34.562 -9.934,9.926 -24.844,15.329 -44.063,15.329 H 288.422 V 410.586 h 33.254 v 48.383"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 502.066,407.996 c 29.161,0 46.442,10.371 61.993,27.004 l -21.18,21.371 c -11.871,-10.789 -22.445,-17.711 -39.727,-17.711 -25.914,0 -43.843,21.598 -43.843,47.524 v 0.425 c 0,25.911 18.359,47.082 43.843,47.082 15.125,0 26.996,-6.48 38.657,-17.058 l 21.164,24.406 c -14.035,13.809 -31.094,23.32 -59.602,23.32 -46.441,0 -78.832,-35.199 -78.832,-78.175 v -0.43 c 0,-43.426 33.039,-77.758 77.527,-77.758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 610.551,471.27 h 67.898 v -60.688 h 33.262 v 151.191 h -33.262 v -59.82 h -67.898 v 59.82 H 577.285 V 410.582 h 33.266 v 60.688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 771.715,561.777 H 738.453 V 410.602 h 33.262 v 151.175"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 862.828,410.59 v 120.512 h 46 v 30.66 H 783.566 v -30.66 h 46 V 410.59 h 33.262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1035.39,440.18 h -82.058 v 31.738 h 71.258 v 29.598 h -71.258 v 30.668 h 80.988 v 29.589 H 920.285 V 410.582 h 115.105 v 29.598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1045.64,485.754 c 0,-43.426 33.03,-77.758 77.53,-77.758 29.16,0 46.43,10.371 61.99,27.004 l -21.18,21.371 c -11.88,-10.789 -22.45,-17.711 -39.73,-17.711 -25.92,0 -43.85,21.598 -43.85,47.524 v 0.425 c 0,25.911 18.36,47.082 43.85,47.082 15.13,0 26.99,-6.48 38.65,-17.058 l 21.17,24.406 c -14.04,13.809 -31.1,23.32 -59.61,23.32 -46.43,0 -78.82,-35.199 -78.82,-78.175 v -0.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1191.39,531.102 h 46 V 410.59 h 33.26 v 120.512 h 46.01 v 30.66 h -125.27 v -30.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1360.24,476.238 v 85.532 h -33.27 v -86.387 c 0,-44.492 24.85,-67.176 65.44,-67.176 40.61,0 66.3,22.473 66.3,68.254 v 85.309 h -33.25 v -86.598 c 0,-23.973 -12.3,-36.285 -32.62,-36.285 -20.3,0 -32.6,12.746 -32.6,37.351"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1575.56,509.719 c 0,-12.742 -9.29,-21.379 -25.49,-21.379 h -33.69 v 43.406 h 33.04 c 16.2,0 26.14,-7.336 26.14,-21.601 z m 33.69,1.73 v 0.43 c 0,14.25 -4.54,26.141 -12.95,34.562 -9.94,9.926 -24.84,15.329 -44.07,15.329 h -69.11 V 410.586 h 33.26 v 48.383 h 26.14 l 32.37,-48.383 h 38.88 l -36.91,54.004 c 19.22,7.129 32.39,22.445 32.39,46.859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1661.79,471.918 h 71.26 v 29.598 h -71.26 v 30.668 h 80.98 v 29.589 H 1628.74 V 410.582 h 115.11 v 29.598 h -82.06 v 31.738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1764,445.152 v -34.57 h 13.39 c 1.09,-12.301 -6.27,-19.859 -21.16,-21.367 l 2.81,-13.613 c 25.7,0.429 39.95,11.871 39.95,40.378 v 29.172 H 1764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 85.957,304.426 c 0,-12.961 -9.7148,-22.895 -26.3476,-22.895 H 33.2695 v 46.211 h 25.6914 c 16.625,0 26.9961,-7.976 26.9961,-22.879 z M 61.7695,357.773 H 0 V 206.582 h 33.2695 v 45.371 h 25.2618 c 33.9062,0 61.1167,18.125 61.1167,53.113 v 0.43 c 0,30.891 -21.8082,52.277 -57.8785,52.277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 165.828,357.773 H 132.566 V 206.582 h 108.633 v 30.242 h -75.371 v 120.949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 305.852,269.863 20.078,49.032 20.093,-49.032 z m 5.179,88.977 -64.789,-152.258 h 33.91 l 13.821,33.918 h 63.929 l 13.821,-33.918 h 34.769 L 341.691,358.84 h -30.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 447.691,357.773 h -30.66 V 206.582 h 32.828 v 96.121 l 73.215,-96.121 h 28.301 v 151.191 h -32.844 v -93.085 l -70.84,93.085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 610.281,302.703 73.207,-96.121 h 28.301 v 151.191 h -32.844 v -93.085 l -70.84,93.085 H 577.449 V 206.582 h 32.832 v 96.121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 771.793,357.766 H 738.535 V 206.594 h 33.258 v 151.172"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 831.031,302.703 73.207,-96.121 h 28.301 v 151.191 h -32.84 v -93.085 l -70.84,93.085 h -30.66 V 206.582 h 32.832 v 96.121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1030.39,204.004 c 27.64,0 49.04,10.793 64.58,23.973 v 65.656 h -65.65 v -28.731 h 33.47 v -21.601 c -8.42,-6.043 -19.22,-9.074 -31.32,-9.074 -26.78,0 -45.786,20.316 -45.786,47.953 v 0.437 c 0,25.703 19.216,47.078 43.416,47.078 17.48,0 27.85,-5.613 39.52,-15.332 l 20.94,25.266 c -15.76,13.379 -32.18,20.73 -59.38,20.73 -45.793,0 -79.27,-35.203 -79.27,-78.179 v -0.434 c 0,-44.695 32.395,-77.742 79.48,-77.742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1205.78,336.395 v -38.883 h -39.09 v -29.797 h 39.09 V 228.84 h 30.67 v 38.875 h 39.1 v 29.797 h -39.1 v 38.883 h -30.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 327.465,153.77 H 294.199 V 2.58984 H 402.824 V 32.832 H 327.465 V 153.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 467.48,65.8672 20.094,49.0348 20.078,-49.0348 z M 472.664,154.844 407.871,2.59766 h 33.914 l 13.817,33.90624 h 63.929 L 533.352,2.59766 h 34.777 L 503.332,154.844 h -30.668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 680.172,60.6836 609.332,153.77 H 578.676 V 2.58984 H 611.5 V 98.6992 L 684.711,2.58984 H 713 V 153.77 H 680.172 V 60.6836"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 843.605,77.7539 c 0,-26.7851 -18.347,-45.1484 -45.554,-45.1484 H 772.348 V 123.75 h 25.703 c 27.207,0 45.554,-18.777 45.554,-45.5664 z M 798.051,153.77 H 739.09 V 2.58984 h 58.961 c 47.515,0 80.336,33.04686 80.336,75.59376 v 0.4297 c 0,42.5387 -32.821,75.1567 -80.336,75.1567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 955.129,93.0742 c -26.145,6.6992 -32.625,9.9458 -32.625,19.8748 v 0.442 c 0,7.324 6.695,13.164 19.441,13.164 12.743,0 25.918,-5.61 39.297,-14.907 l 17.285,25.063 c -15.332,12.305 -34.121,19.219 -56.152,19.219 -30.879,0 -52.91,-18.149 -52.91,-45.571 v -0.425 c 0,-30.0238 19.652,-38.4496 50.098,-46.2231 25.285,-6.4765 30.457,-10.8007 30.457,-19.2187 v -0.4375 c 0,-8.8594 -8.204,-14.25 -21.817,-14.25 -17.273,0 -31.531,7.1211 -45.125,18.3476 L 883.414,24.6172 C 901.555,8.42969 924.672,0.4375 947.57,0.4375 c 32.598,0 55.5,16.8359 55.5,46.8477 v 0.4414 c 0,26.3554 -17.289,37.3632 -47.941,45.3476"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1090.35,30.6641 c -25.9,0 -43.83,21.5937 -43.83,47.5195 v 0.4297 c 0,25.9177 18.35,47.0777 43.83,47.0777 15.13,0 27.01,-6.48 38.67,-17.058 l 21.16,24.402 c -14.04,13.813 -31.1,23.32 -59.61,23.32 -46.44,0 -78.83,-35.195 -78.83,-78.1714 V 77.7539 C 1011.74,34.3242 1044.79,0 1089.28,0 c 29.16,0 46.43,10.3711 61.98,27.0039 l -21.18,21.3633 c -11.87,-10.7891 -22.44,-17.7031 -39.73,-17.7031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1212.03,65.8672 20.09,49.0348 20.09,-49.0348 z m 5.19,88.9768 -64.79,-152.24634 h 33.9 l 13.83,33.90624 h 63.92 L 1277.9,2.59766 h 34.78 l -64.8,152.24634 h -30.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1409.17,100.43 c 0,-12.9573 -9.72,-22.9027 -26.36,-22.9027 h -26.34 V 123.75 h 25.7 c 16.63,0 27,-7.988 27,-22.891 z m -24.19,53.34 H 1323.2 V 2.58984 h 33.27 V 47.9492 h 25.27 c 33.91,0 61.11,18.1367 61.11,53.1248 v 0.43 c 0,30.891 -21.8,52.266 -57.87,52.266"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1488.81,63.9258 h 71.27 v 29.582 h -71.27 v 30.6802 h 80.99 V 153.77 H 1455.77 V 2.58984 h 115.1 V 32.1797 h -82.06 v 31.7461"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaplWordmark);
export default __webpack_public_path__ + "static/media/SAPL-wordmark.93fc9af68b9df60fbd4f8d1e6e192962.svg";
export { ForwardRef as ReactComponent };